export default function TetherSmall() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 10 10">
            <g id="Mask_Group_350" data-name="Mask Group 350" >
                <path id="tether" d="M7.621,5.4V4.27h2.692V2.487H2.841V4.27h2.7V5.4c-2.262.1-3.96.537-3.96,1.057s1.7.95,3.96,1.057v3.729H7.621V7.513c2.262-.1,3.96-.536,3.96-1.057S9.885,5.5,7.621,5.4ZM6.581,7.175c-2.449,0-4.434-.361-4.434-.8,0-.375,1.446-.689,3.392-.773V6.882c.335.014.683.023,1.04.023s.708-.008,1.04-.023V5.605c1.946.084,3.392.4,3.392.773,0,.44-1.982.8-4.431.8Z" transform="translate(-1.581 -1.864)" fill="#7c7c7c" />
            </g>
        </svg>

    )
}